module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_4_3_w_1164.7016fd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_4_3_w_1164.jpg
// module id = 2FeS
// module chunks = 0